import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./header";

const API_ENDPOINT = API_URL + '/api';

export function signIn(params) {
    return axios.get(`${API_ENDPOINT}/Auth/v2`, { headers: getHeaderOptions(), params: params });
}

export function signUp(data) {
    return axios.post(`${API_ENDPOINT}/account`, data, { headers: getHeaderOptions() })
}

export function topPlaces() {
    // return axios.get(`https://devapi.nesiyatova.com/api/ntadvertisement`, { headers: getHeaderOptions() })
    return axios.get(`${API_ENDPOINT}/ntadvertisement`, { headers: getHeaderOptions() })
}

export function uploadAds(data){
    let obj = {
        ...getHeaderOptions(),
        Authorization: 'Bearer ' + localStorage.getItem('token')
    }
    let userId = localStorage.getItem('_lr_id_')
    console.log(userId, "user")
    return axios.post(`${API_ENDPOINT}/ntadvertisement/${'65c1eda6-d9bf-4fb2-b834-7903d57a0fde'}`, data, { headers: obj })
}

export async function userDetail() {
    let obj = {
        ...getHeaderOptions(),
        Authorization: 'Bearer ' + localStorage.getItem('token')
    }
    return await axios.get(`${API_ENDPOINT}/user`, { headers: obj })
}

export function forgotPassword(params) {
    return axios.post(`${API_ENDPOINT}/AccountManager/ForgotPasswordRequest`, null, { headers: getHeaderOptions(), params: params })
}

export function resetPassword(data, params) {
    return axios.post(`${API_ENDPOINT}/AccountManager/ResetPassword`, data, { headers: getHeaderOptions(), params: params })
}

export function refresh(params) {
    return axios.get(`${API_ENDPOINT}/Auth/v2/refresh`, { headers: getHeaderOptions(), params: params });
}